<script>
import DidoPagination from "./components/Pagination.vue";

export default {
  name: "DidoPaginationCe",
  components: {
    DidoPagination,
  },
  props: {
    didoUrl: { type: String, required: true },
    didoFilter: { type: String, required: false, default: void 0 },
  },
  emits: [
    "click-card",
    "label-selection-on-card",
    "bad-configuration",
    "new-page",
    "init",
  ],
  template: `
    <DidoPagination
      :api-url="didoUrl"
      :pagination-filter="didoFilter"
      @click-card="$emit('click-card', $event)"
      @label-selection-on-card="$emit('label-selection-on-card', $event)"
      @bad-configuration="$emit('bad-configuration')"
      @new-page="$emit('new-page', $event)"
      @init="$emit('init', $event)"
    />`,
};
</script>
